import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import "./styles/tailwind.css";

const root = document.getElementById("root");
if (!root) throw new Error("Widget root element missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
